 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		40: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"commons","2":"d89bddc89ef4cfedaefb9e361fd822c2b670061a","3":"7fb66ed33509ffdaf245957ce4d9ef12eab16806","4":"845158aa38446b5428f6bc93266b2b875229545d","6":"component---src-pages-404-js","7":"component---src-pages-company-about-js","8":"component---src-pages-company-careers-js","9":"component---src-pages-company-our-team-js","10":"component---src-pages-contact-js","11":"component---src-pages-cookie-policy-js","12":"component---src-pages-dir-1-js","13":"component---src-pages-dir-2-js","14":"component---src-pages-explainer-videos-js","15":"component---src-pages-index-js","16":"component---src-pages-media-js","17":"component---src-pages-privacy-policy-js","18":"component---src-pages-services-public-sector-js","19":"component---src-pages-services-rpa-as-a-service-js","20":"component---src-pages-services-rpa-managed-support-services-js","21":"component---src-pages-services-staff-augmentation-js","22":"component---src-pages-services-technology-integration-managed-support-services-js","23":"component---src-pages-solutions-artificial-intelligence-js","24":"component---src-pages-solutions-chatbots-js","25":"component---src-pages-solutions-intelligent-automation-js","26":"component---src-pages-solutions-intergration-platform-ibm-sterling-js","27":"component---src-pages-solutions-middleware-integration-js","28":"component---src-pages-solutions-rpa-js","29":"component---src-templates-blog-blog-list-v-2-js","30":"component---src-templates-case-study-case-studies-list-js","31":"component---src-templates-making-work-matter-js","32":"component---src-templates-news-news-list-js","33":"component---src-templates-post-view-js","34":"component---src-templates-thank-you-js","35":"component---src-templates-webinar-webinar-list-js","36":"component---src-templates-white-paper-white-paper-list-js","37":"component---src-templates-white-paper-whitepaper-js","38":"component---src-templates-why-robot-js"}[chunkId]||chunkId) + "-" + {"1":"dd9e54e2dc7eb7496749","2":"530c6c228622adfc9d0f","3":"9045613b0984e8e14137","4":"4a5771449d5ed61e5c25","6":"6c9751f3aadf52c218f3","7":"6eaf36430edcccc103f2","8":"c9f02f5ca865d88027e5","9":"7309d0cbc798de8671c4","10":"2551484f4743824cb176","11":"874f6bff52ad3ed65d7b","12":"592a5326f491ed842107","13":"c954b964d75cdc4b42f1","14":"d48436b01dcb09639592","15":"fa746140b05bd36607ce","16":"86433f499d549fccde7f","17":"db2af5942ce08a0f25c6","18":"96f6774a76769b90612b","19":"0f056b34dfe6e57b1578","20":"a9ba7f7fab55e2c64cd6","21":"6577ea735cb5655ed293","22":"dbf132718dbb9bb5afb9","23":"93ab785770920f2f71fc","24":"d6ff053d2598b8c37d61","25":"3de4a9aee3a9a251fa9a","26":"6d2198585db1cd1901cf","27":"8a73bc12480bc07d3f41","28":"802cb92fb505c674175e","29":"d962e74b1e44b1336dd5","30":"86f5d44a52525174fefb","31":"6f6f0b0da1865cefe85b","32":"9afa7787b429912dafc6","33":"668f960aa0fd9fffb37e","34":"5396ad48dfa23e7c570a","35":"95c6f6cd86e1094bce02","36":"ca1ffb77a70072023e2f","37":"77a2afcc7e7c184bf7d3","38":"d35fa005079a6f78d78f","41":"1ce8a9443ed8f674fc6b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
